import React from 'react';
import clsx from 'clsx';
import * as PropTypes from 'prop-types';
import { Button, Typography } from '@material-ui/core';

import useStyles, { LoadingProgress } from './styles';

const Loading = ({ className, loading, error, errorText, errorButtonText, onErrorButtonClick }) => {
    const classes = useStyles();
    return (
        <div className={clsx(classes.root, className)}>
            {loading && <LoadingProgress className={classes.loading} />}
            {error && (
                <>
                    <Typography variant="body1" color="error">
                        {errorText}
                    </Typography>
                    {onErrorButtonClick ? (
                        <Button color="secondary" variant="contained" onClick={onErrorButtonClick} className={classes.button}>
                            {errorButtonText}
                        </Button>
                    ) : (
                        <Button
                            color="secondary"
                            variant="contained"
                            component="a"
                            href={window.location.href}
                            className={classes.button}
                        >
                            {errorButtonText}
                        </Button>
                    )}
                </>
            )}
        </div>
    );
};

Loading.defaultProps = {
    className: undefined,
    errorText: undefined,
    errorButtonText: undefined,
    onErrorButtonClick: undefined,
};

Loading.propTypes = {
    className: PropTypes.string,
    errorText: PropTypes.string,
    errorButtonText: PropTypes.node,
    onErrorButtonClick: PropTypes.func,
    loading: PropTypes.bool.isRequired,
    error: PropTypes.bool.isRequired,
};

export default Loading;
